import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";

import * as projectActions from "../../actions/projectActions";

import { formatDate } from "../../helpers/date";

import ProgressBar from "../common/ProgressBar";

import MonthlySegmentProgressBarInfo from "./MonthlySegmentProgressBarInfo";
import { getProjectClassName } from "./ProjectProgressBar";

const MonthlySegmentProgressBar = ({
  projectId,
  project,
  actions,
  height,
  showDetails,
  date
}) => {
  useEffect(() => {
    if (projectId) {
      actions.getProject(projectId);
    }
  }, [actions, projectId]);

  const currentMonthlySegment = useMemo(
    () =>
      project.budget_segments?.find(
        (segment) =>
          new Date(date) >= startOfDay(new Date(segment.startDate)) &&
          new Date(date) <= endOfDay(new Date(segment.endDate))
      ),
    [project, date]
  );

  if (!currentMonthlySegment) {
    return null;
  }

  const percentage =
    (currentMonthlySegment.consumed / currentMonthlySegment.budgetHours) * 100;

  const classNames = getProjectClassName(percentage);

  return showDetails ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 15,
        padding: "5px 20px 0 20px"
      }}
    >
      <div style={{ flexGrow: 1 }}>
        <small>
          {`Monthly Segment ${formatDate(
            new Date(currentMonthlySegment.startDate),
            "MM/dd/yyyy"
          )} -
          ${formatDate(new Date(currentMonthlySegment.endDate), "MM/dd/yyyy")}`}
        </small>
        <div style={{ flexGrow: 1 }}>
          <ProgressBar values={[{ percentage, classNames }]} height={height} />
        </div>
      </div>
      <div style={{ whiteSpace: "nowrap", paddingTop: 10 }}>
        <MonthlySegmentProgressBarInfo
          project={project}
          currentMonthlySegment={currentMonthlySegment}
        />
      </div>
    </div>
  ) : (
    <div style={{ marginLeft: 5, marginRight: 5 }}>
      <ProgressBar values={[{ percentage, classNames }]} height={height} />
    </div>
  );
};

MonthlySegmentProgressBar.propTypes = {
  actions: PropTypes.object.isRequired,
  projectId: PropTypes.string,
  project: PropTypes.object,
  height: PropTypes.number,
  showDetails: PropTypes.bool,
  date: PropTypes.object
};

MonthlySegmentProgressBar.defaultProps = {
  project: {},
  date: new Date()
};

function mapStatesToProps(state) {
  return {
    project: state.reducers.project
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...projectActions
      },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(MonthlySegmentProgressBar)
);
